export const AMAZON_CODE_ID_QUERY_PARAM = 'amazonCode'
